import type { IssuedQuoteVersion } from '@repo/api-contracts';
import type { ReactElement } from 'react';

interface OrderTermsProps {
  readonly version: IssuedQuoteVersion;
}

/**
 * 거래 조건 — 내 견적 요청 내용과 같은 이름/값 줄(상자 없이 얇은 선)과 그 아래 발행본 공통 문구.
 */
export const OrderTerms = ({ version }: OrderTermsProps): ReactElement => {
  const rows = [
    { label: '제작 착수', value: version.productionStartNote },
    { label: '납기', value: version.deliveryNote },
    { label: '공급 방법', value: version.deliveryMethodNote },
    { label: '특약 사항', value: version.specialTerms ?? '없음' },
  ];

  return (
    <div className="flex flex-col gap-4">
      <dl className="divide-y divide-foreground/10 border-y border-foreground/10 text-sm wrap-anywhere">
        {rows.map((row) => (
          <div key={row.label} className="flex gap-4 py-3">
            <dt className="w-24 shrink-0 text-muted-foreground sm:w-28">{row.label}</dt>
            <dd className="min-w-0 flex-1 whitespace-pre-wrap">{row.value}</dd>
          </div>
        ))}
      </dl>
      <p className="text-xs leading-relaxed whitespace-pre-wrap text-muted-foreground">
        {version.termsText}
      </p>
    </div>
  );
};
